import { DefaultService } from '@/services/DefaultService';

export default class LinhaProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(cliente) {
        return this._http.post(`${this._env}/promotor/produto/linha`, cliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/produto/linha/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/produto/linha/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    changeSituacao(linha) {
        return this._http.post(`${this._env}/product/linhaproduto/updatesituacao`, linha, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order, page, limit, subgrupo, situacao, ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/linha.json?page=${page}&column=${column}&order=${order}&limit=${limit}&subgrupo=${subgrupo}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(column, order, page, limit, subgrupo, situacao, ...param) {
        return this._http.get(encodeURI(`${this._env}/product/combo/line.json?page=${page}&column=${column}&order=${order}&limit=${limit}&subgrupo=${subgrupo}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findByGrupoAndSubgrupo(page, limit, idgrupoproduto, idsubgrupoproduto) {
        return this._http.get(`${this._env}/promotor/produto/grupo-subgroup-line.json?page=${page}&limit=${limit}&ids=${idgrupoproduto};${idsubgrupoproduto}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    // @84563 - Obter subgrupoproduto que tenha a descrição e seja associado ao grupoproduto informado
    loadComboSubGrupo(idempresa, search) {
        return this._http.get(encodeURI(`${this._env}/product/linhasubgrupocombo.json?idempresa=${idempresa}&search=${search}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}